import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Детски чаршафи от 100% памук | Голямо разнообразие от размери | GoToBed',
  description:
    'Детски чаршафи от 100% памук за детско легло. Ранфорс и памучен сатен, размери 115/155, 120/200, 150/220, 200/240. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Детски чаршафи от 100% памук
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Детски чаршафи от 100% памук – голямо разнообразие от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете детски чаршафи от 100% памук в едноцветни и шарени (с принт)
          десени, подходящи за бебешки и детски легла. Чаршафите се изработват по поръчка, което
          позволява да предложим голямо разнообразие от размери за различни детски матраци -
          например 60/120, 70/140, 82/190 и 90/200, като чаршафите се изработват в по-големи размери
          за удобно покриване и подпъхване. Изработват се от висококачествени памучни платове
          ранфорс и памучен сатен, които са дишащи, меки и подходящи за чувствителната детска кожа.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyDetskiCharshafi />;
}

function SeoBodyDetskiCharshafi() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Детски чаршафи – чаршаф за детско легло от 100% памук */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Детски чаршафи – чаршаф за детско легло от 100% памук
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Детските чаршафи за детско легло са важна част от детското спално бельо, защото осигуряват
        комфорт и приятна среда за сън. Един качествен чаршаф за детско легло от 100% памук
        осигурява мекота, добра дишаемост и комфорт по време на сън.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете детски чаршафи от 100% памук, които са меки, дишащи и подходящи
        за ежедневна употреба. В GoToBed предлагаме детски чаршафи от ранфорс и памучен сатен,
        изработени от висококачествени материи със сертификат OEKO-TEX Standard 100. Памучните
        тъкани са подходящи за чувствителната детска кожа и осигуряват комфорт през всички сезони.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако търсите конкретна материя, можете да разгледате нашите
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи памучен сатен
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
        които се изработват от същите висококачествени памучни платове.
      </Typography>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Размери детски чаршафи за детско легло */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Размери детски чаршафи за детско легло
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от основните предимства на нашите продукти е голямото разнообразие от размери, което
          позволява лесно да намерите подходящ чаршаф за детско легло или детски матрак.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Предлагаме детски чаршафи в размери:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '115/155',
            '115/180',
            '110/210',
            '120/200',
            '120/220',
            '130/220',
            '140/220',
            '140/240',
            '150/220',
            '150/240',
            '160/220',
            '160/240',
            '170/240',
            '180/220',
            '180/240',
            '200/220',
            '200/240',
            '220/240'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Благодарение на този широк избор можете да намерите подходящ детски чаршаф както за
          по-малки детски легла, така и за по-големи матраци. Един от най-често използваните размери
          е чаршаф за детско легло 120/200, който е подходящ за много стандартни детски легла и
          матраци.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          За да създадете пълен комплект спално бельо, можете да комбинирате чаршафа с{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-plikove/2/10"
            sx={seoLinkStyle}>
            детски пликове за завивки
          </Typography>{' '}
          и{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-kalufki/2/8"
            sx={seoLinkStyle}>
            детски калъфки за възглавници
          </Typography>
          , изработени от същите памучни материи.
        </Typography>

        {/* H2: Какъв плат да изберете за детски чаршаф? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2, mt: 4 }}>
          Какъв плат да изберете за детски чаршаф?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршафите в тази категория се изработват от висококачествени памучни материи ранфорс и
          памучен сатен, които са удобни и подходящи за детско спално бельо.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ранфорсът е плътен и издръжлив памучен плат, подходящ за ежедневна употреба. Можете да
          разгледате и нашите{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/2"
            sx={seoLinkStyle}>
            детски чаршафи от ранфорс
          </Typography>
          , които са практичен избор за ежедневно използване.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1, mt: 2 }}>
          Памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Памучният сатен е по-гладка и фина материя с мек допир и лек естествен блясък. Ако
          предпочитате по-фина материя, можете да изберете{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/1"
            sx={seoLinkStyle}>
            детски чаршафи от памучен сатен
          </Typography>
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          И двата вида плат са 100% памук, дишащи и комфортни за сън.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          За пълен комплект спално бельо от същата материя можете да комбинирате чаршафа и с{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-plikove/2/10/2"
            sx={seoLinkStyle}>
            детски пликове ранфорс
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-plikove/2/10/1"
            sx={seoLinkStyle}>
            детски пликове памучен сатен
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-kalufki/2/8/2"
            sx={seoLinkStyle}>
            детски калъфки ранфорс
          </Typography>{' '}
          и{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-kalufki/2/8/1"
            sx={seoLinkStyle}>
            детски калъфки памучен сатен
          </Typography>
        </Typography>

        {/* H2: Предимства на нашите детски чаршафи */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2, mt: 4 }}>
          Предимства на нашите детски чаршафи
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>&#10004; изработени от 100% памук</li>
          <li>&#10004; подходящи за бебешка и детска кожа</li>
          <li>&#10004; голям избор от размери</li>
          <li>&#10004; дишащи и комфортни материи</li>
          <li>&#10004; устойчиви при многократно пране</li>
          <li>&#10004; произведени в България</li>
          <li>&#10004; сертификат на платовете OEKO-TEX Standard 100</li>
        </Box>

        {/* H2: Свиваемост на памучния плат */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Свиваемост на памучния плат
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Тъй като чаршафите са изработени от 100% памук, е възможна естествена свиваемост около
          4–5% след първите пранета. Това е нормално свойство на памучните материи и е характерно за
          всички изделия от естествен памук.
        </Typography>

        {/* H2: Популярни размери детски чаршафи */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери детски чаршафи
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>чаршаф за детско легло 115/155 (115х155) см</li>
          <li>чаршаф за детско легло 115/180 (115х180) см</li>
          <li>чаршаф за детско легло 120/200 (120х200) см</li>
          <li>чаршаф за детско легло 150/220 (150х220) см</li>
          <li>чаршаф за детско легло 160/240 (160х240) см</li>
          <li>чаршаф за детско легло 200/240 (200х240) см</li>
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички детски чаршафи се изработват индивидуално след направена поръчка.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>

        {/* H2: Детско спално бельо от 100% памук */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Детско спално бельо от 100% памук
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако търсите качествено детско спално бельо от 100% памук, можете да разгледате и
          останалите продукти в нашия магазин. Предлагаме разнообразие от{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-plikove/2/10"
            sx={seoLinkStyle}>
            детски пликове за завивки
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-charshafi-s-lastik/2/9"
            sx={seoLinkStyle}>
            детски чаршафи с ластик
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-kalufki/2/8"
            sx={seoLinkStyle}>
            детски калъфки за възглавници
          </Typography>
          , изработени от висококачествени памучни материи като ранфорс и памучен сатен.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Всички продукти се изработват в България от платове със сертификат OEKO-TEX Standard 100,
          което гарантира безопасност и комфорт за бебешката и детската кожа.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за детски чаршафи
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер детски чаршаф?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            За да изберете подходящ чаршаф за детско легло, измерете ширината и дължината на
            матрака. Добре е чаршафът да бъде малко по-голям от размера на матрака, за да може да
            покрива добре матрака и да се подпъхва отстрани. Ако матракът е например 120/200 см,
            можете да изберете чаршаф с размер 150/220, 160/240 см или по-голям, за да има
            достатъчно плат за удобно покриване и подпъхване. В нашия магазин ще откриете детски
            чаршафи в много различни размери, което позволява лесно да намерите подходящ вариант.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са памучните чаршафи за деца?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Чаршафите от 100% памук са дишащи, приятни на допир и подходящи за чувствителната
            детска кожа.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се детските чаршафи след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от естествен памук, и детските чаршафи могат да имат свиваемост
            около 4–5% след първите пранета.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какъв плат да избера за детски чаршаф?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Най-популярните материи са ранфорс и памучен сатен. Ранфорсът е по-плътен и устойчив, а
            памучният сатен е по-гладък и фин на допир.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват детските чаршафи?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички чаршафи се изработват в България, специално за всяка поръчка и според избрания
            размер.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
